<template>
  <div>
    <div class="mb-4">
      <v-row>
        <v-col cols="12" md="4">
          <div class="border-card">
            <div class="title mb-4">Informace o hmotnosti</div>
            <v-row>
              <v-col md="9">Hmotnost na začátku léčby</v-col>
              <v-col class="text-right"
                >{{ healthMetricsStatistics?.initial?.weightKg }} Kg</v-col
              >
            </v-row>
            <v-row class="mt-0">
              <v-col md="9">Hmotnost nyní</v-col>
              <v-col class="text-right"
                >{{ healthMetricsStatistics?.current?.weightKg }} Kg</v-col
              >
            </v-row>

            <v-divider class="my-4"></v-divider>
            <v-row class="d-flex justify-space-between mb-4">
              <v-col md="9">Změna hmotnosti</v-col>
              <v-col class="text-right"
                >{{ healthMetricsStatistics.diff?.weightKg }} Kg</v-col
              >
            </v-row>
          </div>
        </v-col>
        <v-col md="8" cols="12">
          <div class="white">
            <LineChart :statsData="weightData" />
          </div>

          <div v-if="print" class="mt-4">
            Graf zobrazuje pouze body s dostupnými daty. Pokud některé údaje v
            grafu chybí, znamená to, že pro dané období nebyla data vyplněna.
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="!hideBmi && healthMetricsStatistics.initial?.bmi">
      <v-row class="no-break">
        <v-col cols="12" md="4" class="no-break">
          <div class="border-card">
            <div class="title mb-4">Informace o BMI</div>
            <v-row>
              <v-col md="9">BMI na začátku léčby</v-col>
              <v-col class="text-right">{{
                healthMetricsStatistics.initial?.bmi.toFixed(1)
              }}</v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col md="9">BMI nyní</v-col>
              <v-col class="text-right">{{
                healthMetricsStatistics.current?.bmi.toFixed(1)
              }}</v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <v-row>
              <v-col md="9">Změna BMI</v-col>
              <v-col class="text-right">
                {{ healthMetricsStatistics.diff?.bmi.toFixed(1) }}
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col md="8">
          <div class="white">
            <LineChart :statsData="bmiData" />
          </div>
          <div v-if="print" class="mt-4">
            Graf zobrazuje pouze body s dostupnými daty. Pokud některé údaje v
            grafu chybí, znamená to, že pro dané období nebyla data vyplněna.
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/charts/LineChart.vue";
import useApiCall from "@/use/apiCall";
import useFormatDate from "@/use/formatDate";

export default {
  components: {
    LineChart,
  },

  setup() {
    const { getData } = useApiCall();
    const { getCzechDateWithoutTime } = useFormatDate();

    return {
      getData,
      getCzechDateWithoutTime,
    };
  },

  data() {
    return {
      healthMetrics: [],
      healthMetricsStatistics: {},
    };
  },

  props: {
    patient: {
      type: Object,
      required: true,
    },
    print: {
      type: Boolean,
      default: false,
    },
    hideBmi: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    weightData() {
      return {
        labels: this.healthMetrics.map((metric) =>
          this.getCzechDateWithoutTime(metric.trackedAtLocal),
        ),
        data: this.healthMetrics.map((metric) => metric.weightKg),
      };
    },
    bmiData() {
      return {
        labels: this.healthMetrics.map((metric) =>
          this.getCzechDateWithoutTime(metric.trackedAtLocal),
        ),
        data: this.healthMetrics.map((metric) => metric.bmi),
      };
    },
  },

  async mounted() {
    await this.fetchHealthMetrics();
    await this.fetchHealthMetricsStatistics();
    this.$emit("loaded");
  },

  methods: {
    async fetchHealthMetricsStatistics() {
      const patientId = Number(this.$route.params.id);
      const params = {
        patientId,
      };

      const statistics = await this.getData(`/health-metrics/statistics`, {
        params,
      });

      this.healthMetricsStatistics = statistics;
    },
    async fetchHealthMetrics() {
      const patientId = Number(this.$route.params.id);

      const from = this.$route.query.from;
      const to = this.$route.query.to;

      const params = {
        patientId,
      };

      if (from) {
        params.from = from;
      }

      if (to) {
        params.to = to;
      }

      const { metrics } = await this.getData(`/health-metrics/`, {
        params,
      });

      this.healthMetrics = metrics;
    },
  },
};
</script>

<style scoped>
@media print {
  .no-break {
    page-break-inside: avoid; /* Avoid breaking inside the element */
    break-inside: avoid; /* Ensures compatibility with modern browsers */
    display: block;
  }
}
</style>
